var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 164.14 56.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 1,
    width: 36.06,
    height: 10.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.04,
    y: 22.66,
    width: 25.02,
    height: 10.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.23,
    y: 44.33,
    width: 35.83,
    height: 10.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.91,44.33H77.07V55.06h-31V1H56.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.11,33.94V1H97.92V33.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.11,55.14V44.59H97.92V55.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.14,28a28,28,0,1,1-28-28A28.08,28.08,0,0,1,164.14,28ZM119.2,28a16.91,16.91,0,1,0,16.91-16.91A16.91,16.91,0,0,0,119.2,28Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.89d704e1.svg";
export { ForwardRef as ReactComponent };